class Common {
  constructor() {
    this.lastScrollY = 0;
    this.isDesktop = window.innerWidth >= 768;
    this.init();
  }

  init() {
    this.drawerEvent();
    // トップは Top クラス側で Lenis 連動のヘッダー制御を行う
    if (!document.querySelector('.js-top')) {
      this.headerScrollControl();
    }
    this.handleResize();
  }

  drawerEvent() {
    $('.js-drawer-btn').on('click', () => {
      $('html').toggleClass('is-drawer-open');
    });
  }

  headerScrollControl() {
    const header = document.querySelector('.js-header');
    if (!header) return;
  
    let lastY = window.pageYOffset;
    let ticking = false;
    const threshold = 10; // ← スクロール方向が10px以上変化したときだけ反応
  
    const update = () => {
      const y = window.pageYOffset;
      const diff = y - lastY;
  
      // --- 閾値未満の微小なスクロールは無視 ---
      if (Math.abs(diff) < threshold) {
        ticking = false;
        return;
      }
  
      // --- スクロール位置が上端近いときは常に表示 ---
      if (y <= 100) {
        header.style.transform = 'translateY(0)';
      } else if (diff > 0) {
        // 下方向（一定以上スクロールしたときのみ隠す）
        header.style.transform = 'translateY(-100%)';
      } else {
        // 上方向
        header.style.transform = 'translateY(0)';
      }
  
      lastY = y;
      ticking = false;
    };
  
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    });
  }
  

  handleResize() {
    window.addEventListener('resize', () => {
      this.isDesktop = window.innerWidth >= 768;
    });
  }
}